export const HamburgerIcon = () => {
  return (
    <svg
      className="max-w-[40px] max-h-[40px] sm:max-h-full sm:max-w-full"
      width="50"
      height="50"
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.99967 8.6665H12.833C13.1424 8.6665 13.4392 8.78942 13.658 9.00821C13.8768 9.22701 13.9997 9.52375 13.9997 9.83317C13.9997 10.1426 13.8768 10.4393 13.658 10.6581C13.4392 10.8769 13.1424 10.9998 12.833 10.9998H6.99967C6.69026 10.9998 6.39351 10.8769 6.17472 10.6581C5.95592 10.4393 5.83301 10.1426 5.83301 9.83317C5.83301 9.52375 5.95592 9.22701 6.17472 9.00821C6.39351 8.78942 6.69026 8.6665 6.99967 8.6665ZM15.1663 17.9998H20.9997C21.3091 17.9998 21.6058 18.1228 21.8246 18.3415C22.0434 18.5603 22.1663 18.8571 22.1663 19.1665C22.1663 19.4759 22.0434 19.7727 21.8246 19.9915C21.6058 20.2103 21.3091 20.3332 20.9997 20.3332H15.1663C14.8569 20.3332 14.5602 20.2103 14.3414 19.9915C14.1226 19.7727 13.9997 19.4759 13.9997 19.1665C13.9997 18.8571 14.1226 18.5603 14.3414 18.3415C14.5602 18.1228 14.8569 17.9998 15.1663 17.9998ZM6.99967 13.3332H20.9997C21.3091 13.3332 21.6058 13.4561 21.8246 13.6749C22.0434 13.8937 22.1663 14.1904 22.1663 14.4998C22.1663 14.8093 22.0434 15.106 21.8246 15.3248C21.6058 15.5436 21.3091 15.6665 20.9997 15.6665H6.99967C6.69026 15.6665 6.39351 15.5436 6.17472 15.3248C5.95592 15.106 5.83301 14.8093 5.83301 14.4998C5.83301 14.1904 5.95592 13.8937 6.17472 13.6749C6.39351 13.4561 6.69026 13.3332 6.99967 13.3332Z"
        fill="white"
      />
    </svg>
  );
};
export const CrossIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.63 8.47C5 9.36667 5 12.0333 5 17.3617V19.985C5 29.3817 12.065 33.9433 16.4983 35.8783C17.7 36.4033 18.3017 36.6667 20 36.6667C21.7 36.6667 22.3 36.4033 23.5017 35.8783C27.935 33.9417 35 29.3833 35 19.985V17.3617C35 12.0317 35 9.36667 34.37 8.47C33.7417 7.575 31.2367 6.71667 26.225 5.00167L25.27 4.675C22.6583 3.78 21.3533 3.33334 20 3.33334C18.6483 3.33334 17.3417 3.78 14.73 4.675L13.775 5C8.76333 6.71667 6.25833 7.575 5.63 8.47ZM16.7167 14.95C16.6022 14.8272 16.4642 14.7287 16.3109 14.6604C16.1576 14.592 15.992 14.5553 15.8242 14.5523C15.6564 14.5494 15.4897 14.5803 15.334 14.6431C15.1784 14.706 15.037 14.7996 14.9183 14.9183C14.7996 15.037 14.706 15.1784 14.6431 15.334C14.5803 15.4897 14.5494 15.6564 14.5523 15.8242C14.5553 15.992 14.592 16.1576 14.6604 16.3109C14.7287 16.4642 14.8272 16.6022 14.95 16.7167L18.2333 20L14.95 23.2833C14.8272 23.3978 14.7287 23.5358 14.6604 23.6891C14.592 23.8424 14.5553 24.008 14.5523 24.1758C14.5494 24.3436 14.5803 24.5104 14.6431 24.666C14.706 24.8216 14.7996 24.963 14.9183 25.0817C15.037 25.2004 15.1784 25.294 15.334 25.3569C15.4897 25.4197 15.6564 25.4506 15.8242 25.4477C15.992 25.4447 16.1576 25.408 16.3109 25.3396C16.4642 25.2713 16.6022 25.1728 16.7167 25.05L20 21.7667L23.2833 25.05C23.5203 25.2708 23.8337 25.391 24.1575 25.3853C24.4814 25.3796 24.7903 25.2484 25.0194 25.0194C25.2484 24.7903 25.3796 24.4814 25.3853 24.1575C25.391 23.8337 25.2708 23.5203 25.05 23.2833L21.7667 20L25.05 16.7167C25.1728 16.6022 25.2713 16.4642 25.3396 16.3109C25.408 16.1576 25.4447 15.992 25.4477 15.8242C25.4506 15.6564 25.4197 15.4897 25.3569 15.334C25.294 15.1784 25.2004 15.037 25.0817 14.9183C24.963 14.7996 24.8216 14.706 24.666 14.6431C24.5103 14.5803 24.3436 14.5494 24.1758 14.5523C24.008 14.5553 23.8424 14.592 23.6891 14.6604C23.5358 14.7287 23.3978 14.8272 23.2833 14.95L20 18.2333L16.7167 14.95Z"
        fill="white"
      />
    </svg>
  );
};
export const TeligramIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        className="w-[20px] sm:w-fit h-auto "
      >
        <g clipPath="url(#clip0_1_36)">
          <path
            d="M10.2018 16.4461L9.77168 22.4954C10.387 22.4954 10.6535 22.2311 10.9731 21.9137L13.858 19.1566L19.8358 23.5344C20.9322 24.1454 21.7046 23.8236 22.0003 22.5258L25.9242 4.13945L25.9253 4.13837C26.273 2.5177 25.3392 1.88395 24.271 2.28153L1.20684 11.1118C-0.36724 11.7228 -0.343407 12.6003 0.93926 12.9979L6.83584 14.8319L20.5324 6.2617C21.177 5.83487 21.7631 6.07103 21.281 6.49787L10.2018 16.4461Z"
            fill="black"
            className="transition-all duration-300 ease-in-out group-hover:fill-[#0279E1]"
          />
        </g>
        <defs>
          <clipPath id="clip0_1_36">
            <rect width="26" height="26" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const TwitterIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      className="w-[20px] sm:w-fit h-auto "
      fill="none"
    >
      <g clipPath="url(#clip0_1_38)">
        <path
          d="M15.4204 11.0092L24.8913 0H22.647L14.4234 9.55916L7.85517 0H0.279541L10.2119 14.4551L0.279541 26H2.52398L11.2084 15.9052L18.1448 26H25.7205L15.4198 11.0092H15.4204ZM12.3463 14.5825L11.3399 13.1431L3.33269 1.68957H6.78002L13.242 10.9329L14.2483 12.3723L22.6481 24.3873H19.2007L12.3463 14.583V14.5825Z"
          fill="black"
          className="transition-all duration-300 ease-in-out group-hover:fill-[#0279E1]"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_38">
          <rect width="26" height="26" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const DexoIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="25"
      className="w-4 sm:w-fit h-auto"
      viewBox="0 0 21 25"
      fill="none"
    >
      <g clip-path="url(#clip0_2098_11)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.81802 1.86975C6.38988 2.6137 5.22146 3.24323 5.2217 3.26883C5.22234 3.33492 8.6493 5.07046 8.77093 5.06623C8.82626 5.06438 9.22764 4.87961 9.66284 4.6557L10.4542 4.24865L11.3186 4.69291L12.1828 5.13727L13.5982 4.50127C15.7309 3.54291 15.9525 3.43789 15.9177 3.40261C15.8717 3.35579 15.1067 2.94485 13.0313 1.85222C12.0283 1.32414 11.0548 0.806372 10.8679 0.701602C10.681 0.596832 10.5026 0.512552 10.4714 0.514183C10.4403 0.515815 9.2462 1.12582 7.81802 1.86975ZM1.55419 5.11338L0.0675015 5.8813V9.25157C0.0675015 11.1052 0.0870231 12.6218 0.110969 12.6218C0.134832 12.6218 0.866284 12.3047 1.73638 11.9172L3.31838 11.2126V7.66012L4.09144 8.0813C4.68716 8.40556 5.28323 8.72916 5.87966 9.0521L6.89478 9.60172L7.34649 9.39746C7.62978 9.26915 7.91251 9.1396 8.19466 9.00879C8.41269 8.90726 8.9479 8.6662 9.38398 8.473C9.82007 8.27972 10.2237 8.08536 10.281 8.04106C10.357 7.98222 9.42983 7.46985 6.85157 6.14586C4.90811 5.14786 3.25566 4.33447 3.17946 4.33837C3.10325 4.34227 2.37188 4.69098 1.55419 5.11338ZM16.1857 5.32903C15.1731 5.78613 14.344 6.17838 14.3431 6.20075C14.3422 6.22309 14.894 6.55123 15.5695 6.92983C16.2449 7.30851 16.7975 7.63858 16.7975 7.66343C16.7975 7.68824 16.1998 7.97783 15.4694 8.3071C14.7389 8.63628 12.8925 9.47012 11.3662 10.1601L6.25206 12.4718C4.9656 13.0533 3.806 13.5775 3.67518 13.6368C1.04751 14.8263 0.325264 15.1564 0.22608 15.213C0.126343 15.2701 0.103752 15.6015 0.086 17.2647L0.0648193 19.2485L1.39428 19.9259L2.72371 20.6033L4.56718 19.7713C5.58111 19.3138 6.41064 18.9155 6.41064 18.8861C6.41064 18.8569 6.22328 18.7348 5.99438 18.6147C5.76538 18.4947 5.29266 18.2289 4.94378 18.024C4.59494 17.8191 4.24709 17.6311 4.17072 17.6061C4.09437 17.5813 4.03302 17.5378 4.03426 17.5094C4.03553 17.4811 4.84731 17.0955 5.8381 16.6525C7.76253 15.7921 9.23525 15.1289 12.397 13.6991C13.8108 13.0599 15.2248 12.421 16.6389 11.7826C17.8818 11.2216 19.3268 10.5664 19.8502 10.3266L20.8016 9.89067L20.8228 7.88428L20.8441 5.87798L19.4957 5.18588C18.754 4.80526 18.1201 4.49477 18.0868 4.4959C18.0536 4.49695 17.1981 4.87182 16.1857 5.32903ZM20.4404 12.5673C20.2417 12.6643 19.8492 12.8461 19.5682 12.9711C19.2872 13.0961 18.754 13.3367 18.3833 13.5058L17.7093 13.8132L17.694 15.5746C17.6855 16.5434 17.6498 17.3317 17.6147 17.3266C17.5349 17.3147 16.2718 16.6669 15.002 15.9866C14.0856 15.4956 14.028 15.476 13.8127 15.5827C13.6882 15.6444 12.9441 15.9781 12.1591 16.3244C11.3741 16.6707 10.7063 16.9766 10.6749 17.0043C10.6436 17.032 12.2234 17.8883 14.1857 18.9072L17.7535 20.7599L19.2776 19.9715C20.1158 19.538 20.8285 19.1425 20.8613 19.0927C20.9352 18.9809 20.9289 12.3755 20.8549 12.3844C20.8257 12.3879 20.6391 12.4702 20.4404 12.5673ZM12.0005 20.3204C11.7362 20.434 11.4719 20.5479 11.2077 20.6618C10.4098 21.007 10.5661 21.0185 9.61686 20.5459C8.98462 20.2312 8.71209 20.1341 8.5938 20.1812C8.50507 20.2166 7.74143 20.5601 6.89669 20.9447C6.05201 21.3292 5.33159 21.6438 5.29575 21.6438C4.94135 21.6438 5.53054 21.9959 7.80409 23.1427L10.4704 24.4876L11.5923 23.9337C12.2093 23.6291 13.4538 23.0191 14.358 22.5782C15.262 22.1371 15.9905 21.7649 15.9769 21.7508C15.9632 21.7368 15.2056 21.3478 14.2934 20.8864L12.6349 20.0475L12.0005 20.3204Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_2098_11">
          <rect
            width="20.8704"
            height="24"
            fill="white"
            transform="translate(0.0648193 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
